<div class="container">
  <div class="content">
    <div
      class="all"
      *ngFor="let item of categories; let i = index"
      [id]="formatId(item.name)"
    >
      <div class="title">
        <span></span>
        {{ item.name }}
      </div>
      <div class="detail detail-first" *ngIf="i === 0">
        <div class="card" *ngFor="let item of item.tags; let i = index">
          <div class="item">
            <div class="part1">
              <span>{{ item.name }}</span>
            </div>
            <div class="part2">
              <div
                class="part2-item"
                *ngFor="let item1 of item.articles"
                (click)="gotoArticle(item1)"
              >
                <span></span> {{ item1.title }}
              </div>
            </div>
            <div class="part4" [routerLink]="'/helping/detail/' + item.id">
              查看全部文章
            </div>
          </div>
        </div>
      </div>
      <div class="detail detail-second" *ngIf="i !== 0">
        <div class="card" *ngFor="let item of item.tags; let i = index">
          <div class="item">
            <div class="part1">
              <app-image
                [fileid]="item.cover"
                width="120px"
                height="60px"
              ></app-image>
            </div>
            <div class="part2">
              <div
                class="part2-item"
                *ngFor="let item1 of item.articles"
                (click)="gotoArticle(item1)"
              >
                <span></span> {{ item1.title }}
              </div>
            </div>
            <div class="part3" [routerLink]="'/helping/detail/' + item.id">
              进入{{ item.name }}知识库
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
